import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TimKiemService, DanhMucService } from '../../services';
import { environment } from 'environments/environment';
// import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent implements OnInit {
  tuKhoaTimKiem: any = [];
  keyword: any[];
  lstDiemDoSelected: any = [];

  constructor(private route: Router, private timKiemService: TimKiemService,
    private danhMucService: DanhMucService
    // private subscription:Subscription
  ) {

  }

  ngOnInit() {
    var timKiemValue = localStorage.getItem(environment.timKiemKey);
    this.tuKhoaTimKiem = timKiemValue;
    // this.subscription = this.danhMucService.navItem$.subscribe(
    //   item => {
    //     this.tuKhoaTimKiem = "";
    //     localStorage.setItem(environment.timKiemKey,"");
    //   }
    // );
  }
  selectEvent(event) {

    let filtered: any[] = [];
    let query = event.query;
    this.timKiemService.timKiemAutoComplete(query).subscribe(res => {
      this.lstDiemDoSelected = (res).data;
      for (let i = 0; i < this.lstDiemDoSelected.length; i++) {

        let country = this.lstDiemDoSelected[i];
        filtered.push(country);
      }

      this.keyword = filtered;
    })


  }

  timKiem() {

    if (this.tuKhoaTimKiem.socongto == undefined && this.tuKhoaTimKiem == undefined) {
      alert('Nhập từ khóa cần tìm kiếm');
      return;
    }
    if (this.tuKhoaTimKiem.socongto != undefined) {

      localStorage.setItem(environment.timKiemKey, this.tuKhoaTimKiem.socongto);
      this.timKiemService.timKiem(this.tuKhoaTimKiem.socongto);
      this.route.navigate(['timkiem']);
    }
    else if (this.tuKhoaTimKiem != "") {
      localStorage.setItem(environment.timKiemKey, this.tuKhoaTimKiem);
      this.timKiemService.timKiem(this.tuKhoaTimKiem);
      this.route.navigate(['timkiem']);
    }
    else {
      alert('Nhập từ khóa cần tìm kiếm');
    }
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-sidebar/app-sidebar.component.ts